import { create } from 'zustand';
import { fetchSmallBodies, type SmallBody } from '../lib/objects';

interface SmallBodiesState {
  loaded: boolean;
  loading: boolean;
  error: string | null;
  bodies: SmallBody[];
  load: () => Promise<void>;
}

export const useSmallBodies = create<SmallBodiesState>((set, get) => ({
  loaded: false,
  loading: false,
  error: null,
  bodies: [],
  load: async () => {
    if (get().loaded || get().loading) return;
    set({ loading: true, error: null });
    try {
      const r = await fetchSmallBodies();
      set({
        bodies: r.items,
        loaded: true,
        loading: false,
      });
    } catch (e) {
      set({ error: String(e), loading: false });
    }
  },
}));
